import { render, staticRenderFns } from "./IntegrationCard.vue?vue&type=template&id=8058774c"
import script from "./IntegrationCard.vue?vue&type=script&lang=js"
export * from "./IntegrationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports